import { createContext, useContext } from 'react'

export interface TurnstileSettings {
  turnstileSiteKey?: string
  turnstileTheme?: string
  turnstileSize?: string
}

export const TurnstileSettingsContext = createContext<TurnstileSettings>({})

export const useTurnstileSettings = (): TurnstileSettings =>
  useContext(TurnstileSettingsContext)
